import React from "react";
import dayjs from "dayjs";

import Controls from "../form/controls/Controls";
import { dataStateType, statusOption } from "src/constants/status";
import DateRangePicker from "../dateRangePicker/DateRangePicker";
import PageSize from "../pageSize/PageSize";

const labelSearchText = "Tìm kiếm";

const formatDateRange = (dateRange) => {
  if (!dateRange || dateRange.length !== 2) {
    return null;
  }

  const [startDate, endDate] = dateRange;
  return {
    start: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
    end: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null,
  };
};

const statusColor = (status) => {
  if (status === dataStateType.ACTIVE) return "#349eff";
  if (status === dataStateType.INACTIVE) return "red";

  return "black";
};

const ControlPanelSystem = ({
  searchKey,
  handleInputChange,
  limit,
  setLimit,
  setNumberPage,
  status,
  setStatus,
  setStartDate,
  setEndDate,
  isDisplayDatePicker = true,
}) => {
  const handleFilterStatus = (e) => {
    const { value } = e.target;
    setStatus(value);
    setNumberPage(1);
  };

  const handleDateChange = (newValue) => {
    const formattedDateRange = formatDateRange(newValue);
    if (formattedDateRange) {
      // Thực hiện tìm kiếm với formattedDateRange.start và formattedDateRange.end
      setStartDate(formattedDateRange.start);
      setEndDate(formattedDateRange.end);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>
        <Controls.InputSearch
          name="search"
          value={searchKey}
          label={labelSearchText}
          type="text"
          onChange={handleInputChange}
        />

        <PageSize
          limit={limit}
          setLimit={setLimit}
          setNumberPage={setNumberPage}
        />

        <div style={{ display: "flex" }}>
          <Controls.Select
            name="statusFilter"
            label="Status"
            style={{ width: "120px", marginRight: "10px" }}
            value={status}
            colorText={statusColor(status)}
            onChange={handleFilterStatus}
            options={statusOption}
          />
          {isDisplayDatePicker ? (
            <DateRangePicker onValueChange={handleDateChange} />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ControlPanelSystem;
